// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__IXGi3","wrapper":"style_wrapper__e7Ob+","mobile":"style_mobile__O9Oef","laptop":"style_laptop__+cpuV"};